import {
  ListItem,
  ListItemAvatar,
  ListItemText,
  Skeleton,
} from '@presov.sk/presov-ui-react';
import React from 'react';

const NotificationsListItemSkeleton: React.FC = () => {
  return (
    <ListItem
      alignItems='flex-start'
      sx={{
        '&:not(:last-child)': {
          borderBottom: '1px solid',
          borderColor: 'divider',
        },
      }}
    >
      <ListItemAvatar>
        <Skeleton variant='circular' width={40} height={40} />
      </ListItemAvatar>
      <ListItemText
        primary={<Skeleton variant='text' width='80%' height={24} />}
        secondary={
          <>
            <Skeleton variant='text' width='95%' />
            <Skeleton variant='text' width='60%' />
          </>
        }
      />
    </ListItem>
  );
};

export default NotificationsListItemSkeleton;
